<template>
  <mdb-container class="d-flex justify-content-center wrapper2" center fluid>
    <mdb-container class="d-flex justify-content-center fluid firstrow2">
      <hotdealcarousel3 class="d-none d-sm-block" :list-array="filterImage(cars)" />
      <mbhotdealcarousel3 class="d-sm-none" :list-array="filterImage(cars)"/>
    </mdb-container>
  </mdb-container>
</template>

<script>
import hotdealcarousel3 from '@/components/HotdealCarousel3.vue';
import mbhotdealcarousel3 from '@/components/mobile/MbHotdealCarousel3.vue';
import { car } from '@/api';

export default {
  data() {
    return {
      cars: [],
    };
  },
  components: {
    hotdealcarousel3,
    mbhotdealcarousel3,
  },
  created() {
    this.fetchData();
  },
  methods: {
    /* eslint-disable */
    filterImage(Value) {
      return Value.filter((item) => {
        return item.hotdealYn === 'y';
      });
    },
    fetchData() {
      car.fetch()
        .then((data) => {
          this.cars = data.data;
        })
        .finally(() => {
        });
    },
  },
};
</script>

<style scoped>
.container-fluid {
  max-width: 100%;
  height: auto;
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
}
.wrapper2 {
  background-color: #212121;
  max-width: 1900px;
  height: auto;
  margin: 0px 0px;
  padding: 0px 0px;
  align-content: center;
  align-items: center;
  align-self: center;
}
.firstrow2 {
  margin: 0px 0px !important;
  height: auto !important;
  max-width: 1348px;
  background-color: white;
  align-content: center;
  align-items: center;
  align-self: center;
  padding: 0 0px;
}
.container {
  padding: 0 0px;
}
@media (max-width: 500px){
  .wrapper2 {
    background-color: white;
    max-width: 100%;
    height: auto;
    margin: 0px 0px;
    padding: 0px 0px;
  }
}
.vuejs-countdown {
  margin-top: 0px !important;
}
@media (max-width: 500px){
  .vuejs-countdown {
    max-width: 100%;
    height: auto;
    align-items: center;
    margin: auto auto;
    overflow: hidden;
    margin-left: 25%;
  }
}
.countdown {
  max-width: 100%;
  height: auto;
}
</style>
